
<div class="v-flex">
    <c-tag
        v-if      = "isRole(item, 10)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "VW"
    />
    <c-tag
        v-if      = "isRole(item, 5)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "ZÜS"
    />
    <c-tag
        v-if      = "isRole(item, 3)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "WN"
    />
    <c-tag
        v-if      = "isRole(item, 4)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "NN"
    />
    <c-tag
        v-if      = "isRole(item, 2)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "FM"
    />

    <c-tag
        v-if      = "isRole(item, 12)"
        :active   = "false"
        :selected = "selected"
        class     = "tag"
        label     = "NK"
    />

    <c-tag
        v-if      = "isRole(item, 8)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "BT"
    />

    <c-tag
        v-if      = "isRole(item, 13)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "H"
    />

    <c-tag
        v-if      = "isRole(item,11)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "AU"
    />

    <c-tag
        v-if="isRole(item, 6)"
        :active   = "true"
        :selected = "selected"
        class     = "tag"
        label     = "H"
    />
</div>
